import ResourceManager from "@/components/admin/ResourceManager";
import { Field, ImageUploader, TextArea, Toggle } from "@/components/admin/Primitives";

export default function Products() {
  return (
    <ResourceManager
      resource="products"
      title="Products"
      subtitle="Merch, packages and tournament entries. Customers checkout via WhatsApp."
      defaults={{ name: "", slug: "", description: "", price: 0, category: "Merchandise", image_url: "", stock: 100, is_published: true }}
      columns={[
        { key: "image_url", label: "Image" },
        { key: "name", label: "Name" },
        { key: "category", label: "Category" },
        { key: "price", label: "Price", render: (r) => `LKR ${Number(r.price).toLocaleString()}` },
        { key: "stock", label: "Stock" },
        { key: "is_published", label: "Published" },
      ]}
      renderForm={(form, setForm) => (
        <>
          <Field label="Name" value={form.name} onChange={(v) => setForm({ ...form, name: v })} required testid="product-name" />
          <Field label="Slug (auto if empty)" value={form.slug} onChange={(v) => setForm({ ...form, slug: v })} testid="product-slug" />
          <Field label="Category" value={form.category} onChange={(v) => setForm({ ...form, category: v })} testid="product-category" />
          <div className="grid grid-cols-2 gap-3">
            <Field label="Price (LKR)" type="number" value={form.price} onChange={(v) => setForm({ ...form, price: v })} required testid="product-price" />
            <Field label="Stock" type="number" value={form.stock} onChange={(v) => setForm({ ...form, stock: v })} testid="product-stock" />
          </div>
          <TextArea label="Description" rows={5} value={form.description} onChange={(v) => setForm({ ...form, description: v })} required testid="product-description" />
          <ImageUploader value={form.image_url} onChange={(v) => setForm({ ...form, image_url: v })} testid="product-image" />
          <Toggle label="Published" checked={form.is_published} onChange={(v) => setForm({ ...form, is_published: v })} testid="product-published" />
        </>
      )}
    />
  );
}
